import React from 'react'
import EmployeDashboardLayout from './EmployeDashboardLayout'
import Chat from '../../../components/Chat/Chat'

const EmployeChat = () => {
    return (
        <>
            <EmployeDashboardLayout>
                <Chat/>
            </EmployeDashboardLayout>
        </>
    )
}

export default EmployeChat